import { useState, useEffect } from 'react'
import { NavbarProps } from "components/shared/NavbarWithSearch";
import { ErrorMessageState } from "contexts/ErrorMessageContext";
import { SuccessMessageState } from "contexts/SuccessMessageContext";
import useErrorMessageState from "hooks/ui/useErrorMessageState";
import useSuccessMessageState from "hooks/ui/useSuccessMessageState";
import useFirebaseSession from "hooks/useFirebaseSession";
import useInternationalization from "hooks/useInternationalization";
import { useRouter } from "next/router";
import { request } from 'graphql-request'
import { subscriptionCheckQuery } from "./Navbar.utils";
import { baseUrl } from 'services/shared/Environment'
import { NavbarState } from './Navbar.types';

export function useSubscriptionCheckQuery(firebaseId: string) {
  const [loading, setLoading] = useState(true)
  const [data, setData] = useState(null)

  useEffect(() => {
    const fetchData = async () => {
      const result = await request(
        `${baseUrl()}/api/graphql`,
        subscriptionCheckQuery(firebaseId)
      );
      setData(result);
      setLoading(false);
    };
    fetchData();
  }, [firebaseId]);

  const subscriptionHasExpired = data?.user?.subscriptionHasExpired ?? true;

  return { loading, subscriptionHasExpired };
}

export function useNavbarState(props: NavbarProps): NavbarState {
    const { toggleMenu } = props
    const { visitorIsFromIndia } = useInternationalization();
    const { userIsLoggedIn, loggedInUserId } = useFirebaseSession();
    const { subscriptionHasExpired } = useSubscriptionCheckQuery(loggedInUserId);
    const errorMessageState = useErrorMessageState();
    const successMessageState = useSuccessMessageState();
    const { pathname } = useRouter();
    const showSubscribe = pathname !== "/subscribe";
    const showLeftNavContent = pathname !== "/subscribe" && pathname !== "/gift";
    
    return {
        toggleMenu,
        visitorIsFromIndia,
        userIsLoggedIn,
        subscriptionHasExpired,
        errorMessageState,
        successMessageState,
        showSubscribe,
        showLeftNavContent
    }
}